import * as pdfjsLib from 'pdfjs-dist'
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl

const viewer = document.getElementById('viewer')

if (!viewer) {
  throw new Error('PDF viewer container not found.')
}

const fileUrl = viewer.dataset.pdfUrl

if (!fileUrl) {
  throw new Error('PDF URL is missing.')
}

const renderPage = async (pdf, pageNumber) => {
  const page = await pdf.getPage(pageNumber)
  const viewport = page.getViewport({ scale: 2.5 })
  const canvas = document.createElement('canvas')
  canvas.className = 'page-canvas'
  const context = canvas.getContext('2d')

  canvas.width = viewport.width
  canvas.height = viewport.height
  viewer.appendChild(canvas)

  await page.render({
    canvasContext: context,
    viewport,
  }).promise
}

const renderPdf = async () => {
  const pdf = await pdfjsLib.getDocument({
    url: fileUrl,
  }).promise

  for (let i = 1; i <= pdf.numPages; i += 1) {
    await renderPage(pdf, i)
  }
}

renderPdf().catch((error) => {
  console.error(error)
  // Fallback for environments where PDF.js cannot fetch the file
  // (most commonly due to CORS/CSP on remote storage in staging).
  viewer.style.padding = '0'
  viewer.style.gap = '0'
  viewer.style.display = 'block'
  const iframeUrl = `${fileUrl}#toolbar=0`
  viewer.innerHTML = `
    <iframe
      src="${iframeUrl}"
      title="PDF preview"
      style="width:100%;height:100%;border:0;background:#fff"
    ></iframe>
  `
})
